import type { LayerCatalogItem } from '../api'
import { layerLabel, useT } from '../i18n'
import { HintDot } from '../help/HintDot'
import { paletteGradient } from './colormaps'

interface LayerPickerProps {
  layers: LayerCatalogItem[]
  active: string
  onSelect: (id: string) => void
}

/** Базовые слои (kind='raw', не оверлеи) + батиметрия — чипы с образцом палитры. */
export function LayerPicker({ layers, active, onSelect }: LayerPickerProps) {
  const t = useT()
  const base = layers.filter(l => !l.overlay && l.kind === 'raw')
  return (
    <div>
      <div className="eyebrow mb-3 flex items-center gap-1.5">
        {t('maps.layerTitle')}
        <HintDot id="layer" />
        <span className="ml-auto font-normal tracking-[0.1em] text-mist">RAW</span>
      </div>
      <div className="flex flex-wrap gap-1.5">
        {base.map(l => {
          const isActive = l.id === active
          return (
            <button
              key={l.id}
              type="button"
              onClick={() => onSelect(l.id)}
              aria-pressed={isActive}
              className={[
                'flex items-center gap-2 rounded-lg py-1.5 pl-2 pr-2.5 text-sm transition-colors',
                isActive
                  ? 'bg-sonar/10 text-foam shadow-[0_0_0_1px_rgb(var(--accent))]'
                  : 'bg-trench text-mist hover:text-foam',
              ].join(' ')}
            >
              <span
                className="h-3.5 w-3.5 rounded"
                style={{
                  background: paletteGradient(l.palette),
                  boxShadow: 'inset 0 0 0 1px rgba(255,255,255,.15)',
                }}
                aria-hidden
              />
              {layerLabel(l.id)}
            </button>
          )
        })}
      </div>
    </div>
  )
}
